import { useNavigate } from 'react-router-dom';
import './donate.css';

function Donate() {
  const navigate = useNavigate();
  const toHome = () => navigate('/');

  const scrollToBottom = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
  };

  return (
    <div className="donate-total-container">
      <section className="donate-intro">
        <div className="donate-intro-content">
          <h1>Empowering The Next Generation of <br></br>African-American Physicians</h1>
          <p>
            At FAAMS, our mission is to provide financial support and educational opportunities
            to African-American students pursuing careers in medicine. We believe healthcare's
            future depends on diversity and representation at every level.
          </p>
          <div className="donation-button-row">
            <button className="donation-donate-btn" onClick={scrollToBottom}>Donate</button>
            <button className="donation-home-btn" onClick={toHome}>Learn More</button>
          </div>
        </div>
        <div className="scroll-down" onClick={scrollToBottom}></div>
      </section>

      <section className="donation-section">
        <div className="donation-content">
          <div className="donate-form-wrapper">
            <h2>Support The Next Generation of <br />African-American Physicians</h2>
            <div className="zeff-container">
              <iframe
                title="Donation form powered by Zeffy"
                src="https://www.zeffy.com/embed/donation-form/donate-to-impact-lives"
                allowPaymentRequest
                allowTransparency="true"
              ></iframe>
            </div>
          </div>

          <div className="stat-cards">
            <div className="donations-card">
              <i class="fa-solid fa-hospital"></i>
              <p>The healthcare system often builds race into clinical tools in ways that disadvantage people of color.</p>
            </div>
            <div className="donations-card">
              <i className="fa-solid fa-user-doctor"></i>
              <p>Only 5% of U.S. physicians are African American</p>
            </div>
            <div className="donations-card">
              <i className="fa-solid fa-graduation-cap"></i>
              <p>In 2019, just 7.4% of medical school applicants identified as Black or African American</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Donate;
